import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: { autoConnect: false },
});

export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  created_at: string;
}

export interface Offer {
  id: string;
  category_id: string;
  title: string;
  description: string;
  location: string;
  price: number;
  cleaning_fee: number;
  currency: string;
  images: string[];
  amenities: string[];
  capacity: number | null;
  is_available: boolean;
  badges?: string[];
  checkin_instructions?: string;
  latitude?: number;
  longitude?: number;
  airbnb_url?: string;
  airbnb_price_sync_enabled?: boolean;
  airbnb_last_price_sync_at?: string;
  airbnb_last_synced_price?: number;
  created_at: string;
  updated_at: string;
}

export interface Reservation {
  id: string;
  offer_id: string;
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  start_date: string;
  end_date: string;
  num_persons: number;
  status: 'pending' | 'confirmed' | 'cancelled';
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export interface AdminUser {
  id: string;
  email: string;
  full_name: string;
  created_at: string;
}

export interface CurrencyRate {
  id: string;
  currency_code: 'EUR' | 'USD';
  rate: number;
  updated_at: string;
  updated_by: string | null;
}
